import React from 'react';
import { IOrder } from '@/interfaces/order';
import TemplateHeaderExport from './components/template-header-export';
import TemplateOrderInfoExport from './components/template-order-info-export';
import TemplateFooterExport from './components/template-footer-export';
import TemplatePackingList from './components/template-packing-list';
import { useQuery } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { ISearchPackingListRes } from '@/interfaces/packingList';
import { searchpackingLists } from '@/adapters/packingList';
import { chunk, sumBy } from 'lodash';

interface IProps {
  data: IOrder;
}

const TM20 = ({ data }: IProps) => {
  const { data: packingListsResponse } = useQuery<
    AxiosResponse<ISearchPackingListRes>,
    Error
  >({
    queryKey: ['search-packing-list', data],
    queryFn: async () =>
      await searchpackingLists({
        orderId: Number(data?.id),
        pageSize: -1,
        pageStart: 1,
      }),
    enabled: !!data,
  });

  const items = packingListsResponse?.data?.data || [];

  // Calculate totals
  const netWeight = sumBy(items, 'netWeight');
  const grossWeight = sumBy(items, 'grossWeight');
  const totalPackage = sumBy(items, item =>
    sumBy(item.packingListItems ?? [], 'package'),
  );

  // Group items into chunks of 20
  const groupItems = chunk(items, 20);
  const total = items.length;

  return (
    <>
      {groupItems.map((g, i) => (
        <div
          key={i}
          style={{
            maxWidth: '209mm',
            minWidth: '209mm',
            minHeight: '296mm',
            maxHeight: '296mm',
            backgroundColor: 'white',
            margin: '0 auto',
            position: 'relative',
            padding: 20,
            pageBreakBefore: 'always',
          }}
        >
          <TemplateHeaderExport titleEn="PACKING LIST" />

          {i === 0 && (
            <TemplateOrderInfoExport
              data={data}
              code={data.ivNo}
              titleEn="PACKING LIST"
            />
          )}

          <TemplatePackingList
            data={data}
            packingLists={g}
            isMultiPage={i !== groupItems.length - 1} // `true` for pages except the last
            grossWeight={i === groupItems.length - 1 ? grossWeight : undefined}
            netWeight={i === groupItems.length - 1 ? netWeight : undefined}
            totalPackage={
              i === groupItems.length - 1 ? totalPackage : undefined
            }
            totalItem={i === groupItems.length - 1 ? total : undefined}
          />

          <TemplateFooterExport data={data} docNo={data?.code} />
        </div>
      ))}
    </>
  );
};

export default TM20;
